<div class="recommended-articles" *ngIf="articles.length">

    <div class="mobile-swiper-wrapper">
        <swiper-container #swiperRecommendedArticle
                          class="recommended-articles-card-list ap-swiper"
                          slides-per-view="auto"
                          space-between="16">
            <swiper-slide class="ap-swiper__slide" *ngFor="let article of articles | slice:0:5">
                <a class="recommended-articles-card pointer" routerLink="/article/{{article.slug}}">
                    <div class="recommended-articles-card-title">{{ article.title }}</div>
                </a>
            </swiper-slide>
            <swiper-slide class="ap-swiper__slide" *ngIf="articles.length > 5">
                <a class="recommended-articles-see-more-card pointer" [routerLink]="seeMoreRoute">
                    <img src="/assets/icons/see_more_icon.png" class="recommended-articles-see-more-card-icon">
                    <div class="recommended-articles-card-title recommended-articles-card-title--see-more">{{ lang.data['general.see_more'] }}</div>
                </a>
            </swiper-slide>
        </swiper-container>
    </div>

    <div class="desktop-grid-wrapper">
        <div class="recommended-articles-grid">
            <a class="recommended-articles-card pointer"
               *ngFor="let article of articles | slice:0:3"
               routerLink="/article/{{article.slug}}">
                <div class="recommended-articles-card-title">{{ article.title }}</div>
            </a>
        </div>
        <ng-container *ngIf="articles.length > 4">
            <div class="recommended-articles-divider"></div>
            <a class="recommended-articles-see-more"  [routerLink]="seeMoreRoute">
                <img src="/assets/icons/see_more_icon.png">{{ lang.data['general.see_more'] }}
            </a>
        </ng-container>
    </div>

</div>
